import { useContext } from 'react'
import { CartContext } from '../context/Cart'
import { CartItem, Product } from 'types/common-types'
import ProductListItem from './ProductListItem'

interface Props {
	products: Product[]
	region: 'ladoe' | 'standard' | 'teks'
}

export default function ProductList({ products, region }: Props) {
	const { cart } = useContext(CartContext)

	function findInCartAndSetQuantity(product: Product) {
		const item = cart.find((item: CartItem) => item.id === product.sys.id)
		if (item) return item.quantity
		else return 0
	}

	return (
		<div>
			{products
				.filter((product) => product !== null)
				.map((product: Product) => (
					<ProductListItem
						key={product.sys.id}
						cartQuantity={findInCartAndSetQuantity(product)}
						product={product}
						region={region}
					/>
				))}
		</div>
	)
}
